/* Free overgrip with NOX / Bullpadel / Adidas / Siux rackets.
   Config: window.NP_FREEGRIP = {brands:{nox:vid,...}, was:{vid:cents}} (layout/np.liquid).
   Keeps one free grip per qualifying racket in the basket, adds/removes it automatically. */
(function(){
  var C = window.NP_FREEGRIP; if(!C || !window.NP) return;
  var GRIPS = {}; Object.keys(C.brands).forEach(function(b){ GRIPS[String(C.brands[b])] = 1; });
  var busy = false;
  function sync(cart){
    if(busy || !cart || !cart.items) return;
    var need = {}, have = {}, keys = {};
    Object.keys(GRIPS).forEach(function(v){ need[v] = 0; have[v] = 0; });
    cart.items.forEach(function(it){
      var v = String(it.variant_id);
      if(GRIPS[v]){ have[v] += it.quantity; keys[v] = keys[v] || it.key; return; }
      if(it.product_type !== 'Padel Racket') return;
      var g = C.brands[String(it.vendor || '').toLowerCase()];
      if(g) need[String(g)] += it.quantity;
    });
    var jobs = [];
    Object.keys(GRIPS).forEach(function(v){
      if(need[v] === have[v]) return;
      if(!keys[v]) jobs.push(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:+v,quantity:need[v],properties:{_free:'1'}}]})}); });
      else jobs.push(function(){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:keys[v],quantity:need[v]})}); });
    });
    if(!jobs.length) return;
    busy = true;
    jobs.reduce(function(p,f){ return p.then(f); }, Promise.resolve())
      .then(function(){ return NP.getCart(); })
      .then(function(c){ busy = false; NP.emitCart(c); })
      .catch(function(){ busy = false; });
  }
  document.addEventListener('np:cart:changed', function(e){ sync(e.detail); });
  function start(){ NP.getCart().then(sync).catch(function(){}); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
